import Service from "../Service";

const resource = "qryconfiguration/";

export default {
    save(prd, requestID) {
        return Service.post(resource + "save", prd, {
            params: { requestID: requestID },
        });
    },

    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },

    list(obj, requestID) {
        return Service.post(resource + "list", obj, {
            params: { requestID: requestID },
        });
    },

    querygeneral(obj, requestID) {
        return Service.post(resource + "querygeneral", obj, {
            params: { requestID: requestID },
        });
    },

    downloadexcel(obj, requestID) {
        return Service.post(resource + "downloadexcel", obj, {
            responseType: "blob",
            headers: {
                "Content-Type": "application/json",
            },
            params: { requestID: requestID },
            timeout: 300000,
        });
    },


    execuetSQL(obj, requestID) {
        return Service.post(resource + "execuetSQL", obj, {
            params: { requestID: requestID },
        });
    },

    createdToken(requestID) {
        return Service.post(resource + "createdToken", {}, {
            params: { requestID: requestID },
        });
    },

    paginationToken(requestID) {
        return Service.post(resource + "paginationToken", {}, {
            params: { requestID: requestID },
        });
    },

    executeSP(obj, requestID) {
        return Service.post(resource + "executeSP", obj, {
            params: { requestID: requestID },
        });
    },

    downloadexcelTransactSQL(obj, requestID) {
        return Service.post(resource + "downloadexcelTransactSQL", obj, {
            responseType: "blob",
            headers: {
                "Content-Type": "application/json",
            },
            params: { requestID: requestID },
            timeout: 300000,
        });
    },

};